import { FetchError } from 'ofetch'

export interface ErrorMetadata {
  [key: string]: any
}

export const useReportError = () => {
  const bugsnag = useBugsnag()

  const notifyBugsnag = (error: unknown, metadata?: ErrorMetadata) => {
    if (error instanceof Error) {
      bugsnag.notify(error, (event) => {
        // Add API Error metadata for FetchError
        if (error instanceof FetchError) {
          event.addMetadata('apiError', {
            data: error.data,
            responseCode: error.response?.status,
            url: error.response?.url,
          })
        }

        // Add custom metadata if provided
        if (metadata) {
          Object.entries(metadata).forEach(([section, data]) => {
            event.addMetadata(section, data)
          })
        }
      })
    }
    else {
      // Provide more information about non-Error instances
      const errorDetails = {
        originalValue: error,
        valueType: typeof error,
        constructor: error?.constructor?.name,
      }

      bugsnag.notify(new Error('Non-Error instance reported'), (event) => {
        event.addMetadata('unknownError', errorDetails)

        // Add custom metadata if provided
        if (metadata) {
          Object.entries(metadata).forEach(([section, data]) => {
            event.addMetadata(section, data)
          })
        }
      })
    }
  }

  return {
    notifyBugsnag,
  }
}
